import styled from 'styled-components';

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 31.4rem;

  border-radius: ${({ theme }) => theme.borderRadius.radius10};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    max-height: 7rem;
  }
`;

export const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const HeroSectionContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 144rem;
  margin: 6rem auto;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    margin: 4rem 0;
    padding: 0 2rem;
  }
`;
